import { Home, Gift, Ticket, UtensilsCrossed } from 'lucide-react';

export const TIER_COLORS = { bronze: '#CD7F32', silver: '#C0C0C0', gold: '#FFD700', platinum: '#888' };
export const TIER_EMOJI = { bronze: '', silver: '', gold: '', platinum: '' };
export const DAY_NAMES = ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'];

// LocalStorage key for the customer's PIN — keyed by dashboard token so
// multiple devices/customers don't clash on the same browser. Stored in
// plain text on purpose: the token alone already identifies the customer
// and the PIN is short-lived; this is a deliberate UX-vs-security tradeoff
// so the dashboard behaves like a real installable PWA (no re-login on
// page refresh).
export const PIN_STORE_PREFIX = 'lazo_dashboard_pin_';

// Stored when the customer's PIN check succeeds. Used by external surfaces
// (campaign landing page reached via a static printed QR) to auto-recognize
// the customer without forcing a second login on the same device.
// Plain dashboard token only — the PIN never leaves localStorage under
// `PIN_STORE_PREFIX`.
export const DASHBOARD_TOKEN_KEY = 'lazo_dashboard_token';

export const DEFAULT_BRANDING = {
  primary_color: '#D44E20',
  secondary_color: '#3ECF8E',
  background_color: '#111114',
  text_color: '#FFFFFF',
  text_secondary_color: '#888888',
  logo_url: null,
};

// Per richiesta utente: rimosse "Ordina", "Giochi", "Shop", "Invita"
// (in lavorazione). "Premi" e "Coupon" unificati sotto "Premi".
export const TABS = [
  { id: 'home', label: 'Home', icon: Home },
  { id: 'ordina', label: 'Ordina', icon: UtensilsCrossed },
  { id: 'premi', label: 'Premi', icon: Gift },
  { id: 'ordini', label: 'Ordini', icon: Ticket },
];
